import React, { createContext, useState, useContext } from 'react';

const ProjectContext = createContext();

export const useProject = () => {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProject must be used within a ProjectProvider');
  }
  return context;
};

export const ProjectProvider = ({ children }) => {
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(false);

  /**
   * Update the current project with new data.
   * @param {object} updatedProject - The new project object.
   */
  const updateProject = (updatedProject) => {
    setProject(updatedProject);
    // Optional: persist changes to AsyncStorage or API here
    // e.g., saveProjectToStorage(updatedProject);
  };

  /**
   * Clear the current project (e.g., when navigating away).
   */
  const clearProject = () => {
    setProject(null);
  };

  return (
    <ProjectContext.Provider
      value={{
        project,
        setProject,
        updateProject,
        clearProject,
        loading,
        setLoading,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};